<template>
  <div class="form-wrapper">
    <div class="container form-page not-found-client">
      <form-header />

      <div class="row">
        <not-found404/>
      </div>
    </div>

    <div class="container fixed-bottom">
      <div class="row">
        <router-link to="/" class="btn btn-success mt-3 justify-content-center mx-auto article-back-btn">
            {{ $t('article.back_btn') }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/article.css'
import FormHeader from '@/components/form/FormHeader'
import NotFound404 from '@/components/NotFound404'

export default {
  components: {FormHeader, NotFound404},
}
</script>
<style scoped>
  .not-found-client #page-404{
    height: 100%;
  }
</style>